import axios from 'axios';

export const HTTP = axios.create({
  baseURL: `https://courseatk.com/CourseatkAPI/APIs/`
})

